import MuiInputLabel, { type InputLabelProps } from "@mui/material/InputLabel";

export type { InputLabelProps };

export function InputLabel(props: InputLabelProps) {
  return <MuiInputLabel {...props} />;
}
